"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var splitOddEvenElements_1 = require("./splitOddEvenElements");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var LEVELS = {
    1: 'one',
    2: 'two',
    3: 'three',
    4: 'four',
    5: 'five',
};
var DesktopLevels = function (_a) {
    var data = _a.data, level = _a.level;
    var _b = (0, splitOddEvenElements_1.splitOddAndEven)(data), odd = _b.odd, even = _b.even;
    var t = (0, next_intl_1.useTranslations)('translation');
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.desktopContainer },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.desktopInner }, even.map(function (l, idx) { return (react_1.default.createElement("div", { key: "levelEven".concat(idx), className: "".concat(styles_module_scss_1.default.level, " ").concat(styles_module_scss_1.default.levelLeft, " ").concat(styles_module_scss_1.default === null || styles_module_scss_1.default === void 0 ? void 0 : styles_module_scss_1.default[LEVELS[l.level]], " ").concat(level >= l.level ? styles_module_scss_1.default.levelDone : '') },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.status },
                react_1.default.createElement("h2", null, l.name)),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.cashback },
                react_1.default.createElement("p", null, t('dailyCashBack')),
                react_1.default.createElement("h2", null,
                    l.cashback.percent,
                    "%")),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.points },
                react_1.default.createElement("p", null,
                    t('points'),
                    ":"),
                react_1.default.createElement("h2", null, l.fromPoints)),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.prizes },
                l.maxBet && (react_1.default.createElement("div", null,
                    react_1.default.createElement("p", null,
                        t('bonusMaxBet'),
                        ":"),
                    react_1.default.createElement("h2", null, l.maxBet))),
                l.reward && (react_1.default.createElement("div", null,
                    react_1.default.createElement("p", null,
                        t('instantReward'),
                        ":"),
                    react_1.default.createElement("h2", null, l.reward)))),
            react_1.default.createElement("img", { src: l.images.default, alt: "level" }))); })),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.progress }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.desktopInner }, odd.map(function (l, idx) { return (react_1.default.createElement("div", { key: "levelOdd".concat(idx), className: "".concat(styles_module_scss_1.default.level, " ").concat(styles_module_scss_1.default.levelRight, " ").concat(styles_module_scss_1.default === null || styles_module_scss_1.default === void 0 ? void 0 : styles_module_scss_1.default[LEVELS[l.level]], " ").concat(level >= l.level ? styles_module_scss_1.default.levelDone : '') },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.status },
                react_1.default.createElement("h2", null, l.name)),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.cashback },
                react_1.default.createElement("p", null, t('dailyCashBack')),
                react_1.default.createElement("h2", null,
                    l.cashback.percent,
                    "%")),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.points },
                react_1.default.createElement("p", null,
                    t('points'),
                    ":"),
                react_1.default.createElement("h2", null, l.fromPoints)),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.prizes },
                l.maxBet && (react_1.default.createElement("div", null,
                    react_1.default.createElement("p", null,
                        t('bonusMaxBet'),
                        ":"),
                    react_1.default.createElement("h2", null, l.maxBet))),
                l.reward && (react_1.default.createElement("div", null,
                    react_1.default.createElement("p", null,
                        t('instantReward'),
                        ":"),
                    react_1.default.createElement("h2", null, l.reward)))),
            react_1.default.createElement("img", { src: l.images.default, alt: "level" }))); }))));
};
exports.default = DesktopLevels;
